import React, { Component } from "react";
import { Overlay, Popover } from "react-bootstrap";
import api from '../../apiClient/v1';
import * as css from "./comentario.css";

class ComentariosCliente extends Component {
    constructor(props) {
        super(props);
        this.state = {
            marcado: props.comentarios.length > 0 ? true : false,
            show: false,
            comentarios: props.comentarios,
            enableGet: true,
            editando: false,
            confirmarEditar: false,
            checkComentarios: [],
            checked: false,
        };
    }
    handleChangeCheck(e) {
        this.setState({
            editando: true,
            confirmarEditar: true,
            checked: e.target.checked
        });
    }

    handleClick(e) {
        this.setState({
            target: e.target,
            show: !this.state.show
        });
    };

    handleClose() {
        this.setState({
            show: false
        });
    }

    cancelarEditar() {
        this.setState({
            editando: false,
            input: "",
        });
    }

    updateComentarios(comentarios) {
        this.props.updateComentarios(this.props.idLocal, comentarios);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.comentarios !== this.props.comentarios) {
            this.setState({
                comentarios: this.props.comentarios,
                marcado: this.props.comentarios.length > 0 ? true : false
            })
        }
    }

    handleGetComentarios() {
        this.setState({
            enableGet: false
        });
        api.comentariosCliente.getComentarios(this.props.idLocal)
            .then(resp => {
                console.log(resp)
                this.updateComentarios(resp)
                this.setState({
                    enableGet: true
                });
            })
            .catch(err => {
                console.log("Error al actualizar comentario")
            })
    }

    render() {
        let styles = this.state.marcado ? { fontWeight: '900', textDecoration: 'underline' } : { fontWeight: 'normal' };
        return (
            <div style={this.state.show ? { backgroundColor: "#17b485" } : {}}>
                <p onClick={this.handleClick.bind(this)} style={styles}>
                    {this.props.local}
                </p>
                <Overlay
                    show={this.state.show}
                    target={this.state.target}
                    placement="right"
                    onHide={this.handleClose.bind(this)}
                    rootClose
                >
                    <Popover
                        id={this.props.idLocal}
                        bsClass={css.comentario_popover + " popover"}
                    >
                        <div className={css.comentario_container}>
                            {this.state.comentarios.map((comentario) => {
                                return (
                                    <Comentario key={comentario.id}
                                        comentario={comentario}
                                        editable={comentario.editable}
                                        update={this.updateComentarios.bind(this)}
                                        puedeValidarComentarios={this.props.puedeValidarComentarios}
                                    />
                                )
                            })}
                        </div>
                        <FormText
                            idLocal={this.props.idLocal}
                            update={this.updateComentarios.bind(this)}
                            getComentarios={this.handleGetComentarios.bind(this)}
                            enableGet={this.state.enableGet}
                        />
                    </Popover>
                </Overlay>
            </div>
        );
    }
}

export default ComentariosCliente;

class Comentario extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            defaulttext: "",
            input: "",
            editando: false,
            enable: true,
            validado: props.comentario.validado
        }
    }

    handleClick() {
        this.setState({
            editando: true,
            input: this.props.comentario.texto
        })
    }

    handleChangeEditar(e) {
        this.setState({
            input: e.target.value
        });
    }

    cancelarEditar() {
        this.setState({
            editando: false,
            input: "",
        });
    }

    handleValid() {
        api.comentariosCliente.validarComentario(this.props.comentario.id)
            .then(resp => {
                this.props.update(resp);
                this.setState({
                    validado: !this.state.validado
                })
            })
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({
            enable: false
        });
        api.comentariosCliente.editComentario(this.props.comentario.id, {
            comentario: this.state.input.trim()
        })
            .then(resp => {
                this.props.update(resp);
                this.setState({
                    defaulttext: "",
                    input: "",
                    editando: false,
                    enable: true
                });
            })
            .catch(err => {
                console.log("Error al editar comentario")
            })
    }

    render() {
        return (
            <div className={css.comentario_mensaje}>
                {this.props.puedeValidarComentarios ?<div style={{marginLeft: '2px', marginRight: '2px'}}>
                    <button className={this.state.validado ? "btn btn-warning btn-xs" : "btn btn-info btn-xs"} onClick={this.handleValid.bind(this)} disabled={this.state.validado ? true : false}><i className={this.state.validado ? "glyphicon glyphicon-eye-close" : "glyphicon glyphicon-eye-open"}></i> </button>
                </div> : null}
                <p className={css.nombre + " " + css.textoConTooltip}>
                    {this.props.comentario.usuario + ": "}
                    <span>
                        {this.props.comentario.fecha + " "}
                        {this.props.comentario.usuario_completo}
                    </span>
                </p>
                <form onSubmit={this.handleSubmit.bind(this)}>
                    {this.props.editable ?
                        (this.state.editando ?
                            <p>
                                <input className={css.input_comentario_editable} name="comentario" type="text" value={this.state.input} onChange={this.handleChangeEditar.bind(this)} autoFocus required />
                                <button disabled={!this.state.enable} type="submit" className="btn btn-success btn-xs"><i className="glyphicon glyphicon-ok"></i></button>
                                <button onClick={this.cancelarEditar.bind(this)} type="button" className="btn btn-danger btn-xs"><i className="glyphicon glyphicon-remove"></i></button>
                            </p>
                            : <p onClick={this.handleClick.bind(this)} className={css.input_comentario_pointer}>{this.props.comentario.texto}</p>
                        )
                        : <p>{this.props.comentario.texto}</p>
                    }
                </form>
            </div>
        )
    }
}

class FormText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            idComentario: 0,
            defaulttext: "",
            textarea: "",
            visible: false,
            rows: 1,
            enable: true
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCancelar = this.handleCancelar.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({
            enable: false
        });
        api.comentariosCliente.saveComentario(this.props.idLocal, {
            idComentario: this.state.idComentario,
            comentario: this.state.textarea.trim()
        })
            .then(resp => {
                this.props.update(resp);
                this.setState({
                    defaulttext: "",
                    textarea: "",
                    visible: false,
                    rows: 1,
                    enable: true
                });
            })
            .catch(err => {
                console.log("Error al enviar/recibir comentario")
            })
    }

    handleChange(e) {
        this.setState({
            textarea: e.target.value,
            visible: true
        });
        const currentRows = e.target.scrollHeight / 17;
        if (currentRows <= 5) {
            this.setState({ rows: currentRows });
        }
    }

    handleCancelar() {
        this.setState((state) => ({
            textarea: state.defaulttext,
            visible: false
        }));
    }

    render() {
        return (
            <div className={css.formulario} >
                <form onSubmit={this.handleSubmit}>
                    <div className={css.mytextarea}>
                        <textarea
                            ref={(text) => this.textArea = text}
                            onChange={this.handleChange}
                            value={this.state.textarea}
                            maxLength={200}
                            rows={this.state.rows}
                            type="text"
                            name="comentario"
                        />
                        <button disabled={!this.props.enableGet} type="button" onClick={this.props.getComentarios} className="btn btn-primary btn-xs"><i className="glyphicon glyphicon-refresh"></i></button>
                    </div>
                    {this.state.visible
                        ? <div className="">
                            <button disabled={!this.state.enable} type="submit" className="btn btn-success btn-xs"><i className="glyphicon glyphicon-ok"></i></button>
                            <button onClick={this.handleCancelar} type="button" className="btn btn-danger btn-xs"><i className="glyphicon glyphicon-remove"></i></button>
                        </div>
                        : null
                    }

                </form>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./frontEnd/inventarios/programacion-semanal/ComentariosCliente.jsx